// extracted by mini-css-extract-plugin
module.exports = {"loader":"Loader_loader__1j2Bs","spinner":"Loader_spinner__1oBcK","rotate":"Loader_rotate__2CUi0","path":"Loader_path__1uan3","dash":"Loader_dash__1rUgj"};